/* 🤖 this file was generated by svg-to-ts */
export const siriusPaperclip: {
  name: 'paperclip';
  data: string;
} = {
  name: 'paperclip',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.064 2.535a3.75 3.75 0 0 1 4.089 6.114l-.002.002-9.31 9.44a2.25 2.25 0 0 1-3.184-3.18l7.808-7.937a.75.75 0 1 1 1.07 1.051L7.72 15.97a.75.75 0 1 0 1.06 1.06l9.31-9.44a2.25 2.25 0 0 0-3.18-3.183l-9.312 9.441a3.75 3.75 0 0 0 5.304 5.304l7.693-7.683a.75.75 0 1 1 1.06 1.061l-7.693 7.682a5.25 5.25 0 0 1-7.426-7.422l9.312-9.442a3.75 3.75 0 0 1 1.216-.813Z" fill="currentColor"/></svg>`
};
